/**
 * Created by zzy on 2019/8/5.
 */
import AuxiliaryControl from './AuxiliaryControl.vue'
export default AuxiliaryControl



// WEBPACK FOOTER //
// ./src/views/monitoring/auxiliaryControl/index.js